import React from 'react'
import styles from './AboutPage.module.css'
import HeroSection from '../../sections/HeroSection/HeroSection'
import AboutSection from '../AboutSection/AboutSection'
import ValuesSection from '../../sections/ValuesSection/ValuesSection'
import FAQSection from '../../sections/FAQSection/FAQSection'
import ArtistGallery from '../../sections/ArtistGallery/ArtistGallery'
import EventsShowcase from '../../sections/EventsShowcase/EventsShowcase'

const AboutPage = () => {
  return (
    <>
      <HeroSection title="Our Story" image={'/images/29-DSC09440.jpg'} imageAlt="Berli food spread" />
      <AboutSection/>
      <ValuesSection/>
      <EventsShowcase/>

      <ArtistGallery/>
      <FAQSection/>
    </>
  )
}

export default AboutPage